import React, { useEffect, useState } from 'react';
import {
  Alert,
  Avatar,
  Box,
  Button,
  Card,
  CardContent,
  CircularProgress,
  Container,
  MenuItem,
  Modal,
  Pagination,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  TextField,
  Typography,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Tooltip
} from '@mui/material';
import Page from 'src/components/Page';
import Searchbar from 'src/layouts/dashboard/Searchbar';
import { LoadingButton } from '@mui/lab';
import Iconify from 'src/components/Iconify';
import Scrollbar from 'src/components/Scrollbar';
import { UserListHead } from 'src/sections/@dashboard/user';
import Label from 'src/components/Label';
import SearchNotFound from '../components/SearchNotFound';
import { Link as RouterLink } from 'react-router-dom';
import pallete from '../theme/palette';
import { api } from 'src/Api';
import OrderDetailModal from 'src/sections/@dashboard/orders/OrderDetailModal';

export default function Refund_Request() {
  const TABLE_HEAD = [
    { id: 'name', label: 'Buyer', alignRight: false },
    { id: 'amount', label: 'Amount', alignRight: false },
    { id: 'orderno', label: 'Order No', alignRight: false },
    { id: 'remarks', label: 'Remarks', alignRight: false },
    { id: 'status', label: 'Status', alignRight: false },
    { id: 'action', label: 'Action', alignRight: false }
  ];

  const [search, setsearch] = useState('');
  const [searchLoading, setsearchLoading] = useState(false);
  const tableRef = React.createRef();
  const [pagesCount, setpagesCount] = useState(1);
  const [page, setPage] = React.useState(1);
  const [loading, setloading] = useState(false);
  const [listdata, setListData] = useState([]);
  const [permission, setpermission] = useState([]);
  const [openStatusmodal, setOpenStatusModal] = React.useState(false);
  const [reason, setreason] = useState('');
  const [statuslist, setstatuslist] = useState([]);
  const [status, setstatus] = useState('');
  const [statusmodal, setstatusmodal] = useState('');
  const [userid, setuserid] = useState('');
  const [loadingButton, setloadingButton] = useState(false);
  const requirement = ['visible', 'change status', 'details'];
  const [alert, setalert] = useState({ visible: false, message: '' });

  function checkRender() {
    let check = 'refund request';
    const localPerm = JSON.parse(localStorage.getItem('permissions'))?.filter(
      (item) => item.permission_name.toLowerCase() == check
    );
    localPerm[0].permission_types.filter((items) =>
      requirement.includes(items.permission_type_name.toLowerCase())
        ? setpermission((permissions) => [...permissions, items.permission_type_name.toLowerCase()])
        : false
    );
  }
  useEffect(() => {
    checkRender();
  }, []);

  useEffect(() => {
    GetRefundRequest();
    getRefundRequeststatus();
  }, []);

  function handleChangeStatus() {
    setloadingButton(true);
    const token = localStorage.getItem('token');
    const myHeaders = new Headers();
    myHeaders.append('Authorization', `Bearer ${token}`);

    const formdata = new FormData();
    formdata.append('id', userid);
    statusmodal && formdata.append('status', statusmodal?.name);
    reason && reason != undefined && formdata.append('admin_reason', reason);

    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: formdata,
      redirect: 'follow'
    };

    // setloading(true);
    fetch(api.action_refund_request, requestOptions)
      .then((response) => {
        console.log('response =========this action response change status', response);
        if (response.status === 201 || response.status === 200) {
          return response.text().then((result) => ({ status: response.status, body: result }));
        } else {
          return response.json().then((result) => {
            setalert({ visible: true, message: result.error });
          });
        }
      })
      .then(({ body }) => {
        const response = JSON.parse(body);
        handleCloseStatus();
        listdata.length = 0;
        setloading(true);
        GetRefundRequest(page, status);
      })
      .catch((error) => console.log('error', error))
      .finally(() => {
        setloadingButton(false);
      });
  }

  function getRefundRequeststatus() {
    setloading(true);
    const myHeaders = new Headers();

    const token = localStorage.getItem('token');
    myHeaders.append('Authorization', `Bearer ${token}`);

    const requestOptions = {
      method: 'GET',
      headers: myHeaders,
      redirect: 'follow'
    };

    fetch(api.get_withdraw_request_status, requestOptions)
      .then((response) =>
        response.text().then((result) => ({ status: response.status, body: result }))
      )
      .then(({ status, body }) => {
        const result = JSON.parse(body);
        if (status === 200) {
          setstatuslist([{ id: 1, name: 'All' }, ...result.data]);
        } else {
          setstatuslist([]);
        }
      })
      .catch((error) => console.log('error', error))
      .finally(() => {
        // setloading(false);
      });
  }

  function GetRefundRequest(page, statuss) {
    const myHeaders = new Headers();
    const token = localStorage.getItem('token');
    myHeaders.append('Authorization', `Bearer ${token}`);

    const queryParams = new URLSearchParams();
    search.length > 0 && queryParams.append('search', search);
    page && queryParams.append('page', page);
    statuss && statuss?.name != 'All' && queryParams.append('status', statuss?.name);

    const requestOptions = {
      method: 'GET',
      headers: myHeaders,
      redirect: 'follow'
    };

    fetch(`${api.get_refund_request}?${queryParams.toString()}`, requestOptions)
      .then((response) =>
        response.text().then((result) => ({ status: response.status, body: result }))
      )
      .then(({ status, body }) => {
        const result = JSON.parse(body);
        if (status === 200) {
          setListData(result?.data);
          result?.count ? setpagesCount(Math.ceil(result?.count / 20)) : setpagesCount(1);
        } else {
          setListData([]);
          setpagesCount(0);
        }
      })
      .catch((error) => {
        console.log('error', error);
        setpagesCount(0);
      })
      .finally(() => {
        setloading(false);
        setsearchLoading(false);
      });
  }

  const isDataFound = listdata.length === 0;

  const handleChange = (event) => {
    setstatus(event.target.value);
    listdata.length = 0;
    setPage(1);
    setloading(true);
    GetRefundRequest(1, event.target.value);
  };

  const handleCloseStatus = () => {
    setOpenStatusModal(false);
    setstatusmodal('');
    setreason('');
    setalert({ visible: false, message: '' });
  };

  const handlemodalstatuschange = (event) => {
    setstatusmodal(event.target.value);
  };

  const openModal = (id) => {
    setOpenStatusModal(true);
    setuserid(id);
  };

  const style = {
    display: 'flex',
    height: '100%',
    width: '100%',
    justifyContent: 'center',
    alignItems: 'center'
  };

  const boxStyle = {
    maxWidth: '70%',
    maxHeight: '90%',
    bgcolor: 'background.paper',
    boxShadow: 24,
    overflow: 'auto',
    border: '2px solid',
    borderColor: pallete.primary.main
  };

  const handlePageChange = (event, value) => {
    listdata.length = 0;
    setPage(value);
    GetRefundRequest(value, status);
  };

  const [openRemarks, setOpenRemarks] = useState(false);
  const [remarks, setremarks] = useState(null);

  const descriptionElementRef = React.useRef(null);

  const handleCloseRemarks = () => {
    setremarks(null);
    setOpenRemarks(false);
  };
  const handleOpenRemarks = (remarks) => {
    setremarks(remarks);
    setOpenRemarks(true);
  };
  const [details, setdetails] = useState(false);
  const [selectedOrder, setselectedOrder] = useState(null);
  const handleOrderClick = (product) => {
    setselectedOrder(product);
    setdetails(true);
  };

  const getStatusColor = (status) => {
    switch (status.toLowerCase()) {
      case 'approved':
        return 'success';
      case 'on hold':
        return 'info';
      case 'declined':
        return 'error';
      case 'requested':
        return 'warning';
      default:
        return 'primary';
    }
  };

  return (
    <Page title={`Refund Request | ${process.env.REACT_APP_PROJECTNAME}`}>
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={1}>
          <Typography variant="h4" gutterBottom>
            Refund Request
          </Typography>
        </Stack>
        {/* CHANGE STATUS */}
        <Modal
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%',
            width: '100%'
          }}
          open={openStatusmodal}
          onClose={handleCloseStatus}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={{ ...boxStyle, style }} className="admin_modal_pa">
            <Box p={1} py={3} flexDirection={'column'} display={'flex'} flex={1}>
              <Typography variant="h4" style={{ fontWeight: 'bold', textAlign: 'center' }}>
                Change Status
              </Typography>
              <CardContent>
                <TextField
                  style={{
                    width: '100%'
                  }}
                  select
                  value={statusmodal}
                  label={'Status'}
                  onChange={handlemodalstatuschange}
                  className="width_full_status"
                >
                  {statuslist.slice(2).map((option) => (
                    <MenuItem key={option.id} value={option}>
                      {option.value}
                    </MenuItem>
                  ))}
                </TextField>

                <TextField
                  style={{ width: '100%', marginTop: 10 }}
                  id="outlined-multiline-static"
                  label="Reason"
                  multiline
                  rows={4}
                  defaultValue="Default Value"
                  value={reason}
                  onChange={(e) => setreason(e.target.value)}
                />
                <Box mt={2} />
                {alert && alert.visible && <Alert severity="error">{alert.message}</Alert>}

                <Box style={{ marginTop: 20 }} display={'flex'} justifyContent={'flex-end'}>
                  <LoadingButton
                    onClick={() => {
                      handleChangeStatus();
                    }}
                    variant="contained"
                    style={{ marginRight: 5 }}
                    loading={loadingButton}
                  >
                    Save
                  </LoadingButton>
                  <Button
                    color="primary"
                    variant="outlined"
                    onClick={handleCloseStatus}
                    size="large"
                  >
                    Close
                  </Button>
                </Box>
              </CardContent>
            </Box>
          </Box>
        </Modal>

        {/* ORDER DETAIL MODAL */}
        <Modal
          style={style}
          open={details}
          onClose={() => {
            setdetails(false);
          }}
        >
          <Box
            sx={boxStyle}
            px={5}
            pt={2}
            pb={5}
            style={{ backgroundColor: '#fafafb', maxWidth: '80%' }}
          >
            <OrderDetailModal
              handleClose={() => {
                setdetails(false);
              }}
              productDetails={selectedOrder}
            />
          </Box>
        </Modal>
        <Dialog
          open={openRemarks}
          onClose={handleCloseRemarks}
          scroll={'paper'}
          aria-labelledby="scroll-dialog-title"
          aria-describedby="scroll-dialog-description"
        >
          <Box sx={{ minWidth: 600, maxHeight: 500, overflowX: 'hidden' }}>
            <DialogTitle id="scroll-dialog-title">Remarks</DialogTitle>
            <DialogContent dividers={'paper'}>
              <DialogContentText
                id="scroll-dialog-description"
                ref={descriptionElementRef}
                tabIndex={-1}
              >
                {remarks}
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleCloseRemarks}>Cancel</Button>
            </DialogActions>
          </Box>
        </Dialog>

        <Card>
          <Box
            p={2}
            style={{
              flexDirection: 'row',
              display: 'flex',
              flex: 1,
              justifyContent: 'space-between'
            }}
            className="top_options"
          >
            <Searchbar
              width={'90%'}
              value={search}
              onEnter={() => {
                setsearchLoading(true);
                setPage(1);
                listdata.length = 0;
                GetRefundRequest(1, status);
              }}
              setFunction={(val) => {
                setsearch(val);
              }}
              placeholder="Search"
              onClickSearch={() => {
                setsearchLoading(true);
                setPage(1);
                listdata.length = 0;
                GetRefundRequest(1, status);
              }}
            />
            <LoadingButton
              style={{ width: '15%', marginLeft: '2.5%' }}
              loading={searchLoading}
              variant="contained"
              onClick={() => {
                setsearchLoading(true);
                setPage(1);
                listdata.length = 0;
                GetRefundRequest(1, status);
              }}
              className="width_full"
            >
              <Iconify icon="material-symbols:search" sx={{ width: 25, height: 25 }} />
            </LoadingButton>

            <TextField
              style={{
                width: '40%',
                marginLeft: '2.5%'
              }}
              select
              value={status}
              label={'Status'}
              onChange={handleChange}
              className="width_full_status"
            >
              {statuslist.map((option) => (
                <MenuItem key={option.id} value={option}>
                  {option.name}
                </MenuItem>
              ))}
            </TextField>
          </Box>
          <TableContainer sx={{ minWidth: 800 }}>
            <Scrollbar>
              <Table ref={tableRef}>
                <UserListHead headLabel={TABLE_HEAD} rowCount={TABLE_HEAD.length} />
                <TableBody>
                  {listdata?.map((item) => {
                    const { user, order } = item;
                    return (
                      <TableRow key={item.id}>
                        {/* NAME*/}
                        <TableCell>
                          <Stack direction="row" alignItems="center" spacing={1}>
                            <Box>
                              <Avatar alt={item?.user?.name} src={item && item?.user?.avatar} />
                            </Box>
                            <Box>
                              <div className="one-line-ellipsis">{item?.user?.name}</div>
                              <div className="one-line-ellipsis">
                                {(item?.user && item?.user.email) || 'N/A'}
                              </div>
                              <div>{(item?.user && item?.user.contact_no) || 'N/A'}</div>
                            </Box>
                          </Stack>
                        </TableCell>
                        {/* useremail */}
                        <TableCell align="left">
                          <Typography fontSize={12} variant="subtitle2">
                            {(item && item?.amount) || 'N/A'}
                          </Typography>
                        </TableCell>
                        {/* usercontact */}
                        <TableCell align="left">
                          <Typography fontSize={12} variant="subtitle2">
                            {(item && item?.order?.order_no) || 'N/A'}
                          </Typography>
                        </TableCell>
                        <TableCell align="left" style={{ maxWidth: 280, cursor: 'pointer' }}>
                          <Typography
                            fontSize={12}
                            variant="subtitle2"
                            onClick={() => {
                              item?.admin_reason && handleOpenRemarks(item?.admin_reason);
                            }}
                            noWrap
                          >
                            {item?.admin_reason || 'N/A'}
                          </Typography>
                        </TableCell>

                        {/* STATUS */}
                        <TableCell align="left" style={{ maxWidth: 150 }}>
                          {item?.status ? (
                            <Label
                              style={{ height: 30, paddingLeft: 5, paddingRight: 5, width: 80 }}
                              variant="ghost"
                              color={getStatusColor(item?.status)}
                            >
                              <Typography
                                style={{
                                  textTransform: 'capitalize',
                                  fontWeight: 'bold',
                                  fontSize: 12
                                }}
                              >
                                {item?.status}
                              </Typography>
                            </Label>
                          ) : (
                            <Typography
                              style={{
                                textTransform: 'capitalize',
                                fontWeight: 'bold',
                                fontSize: 12
                              }}
                            >
                              {item?.status || 'N/A'}
                            </Typography>
                          )}
                        </TableCell>
                        {/* ACTIONS */}
                        <TableCell style={{ position: 'relative', minHeight: 400 }}>
                          {/* <Box
                            style={{
                              display: 'flex',
                              flexDirection: 'column',
                              alignItems: 'flex-start'
                            }}
                          >
                            {permission.includes('change status') && (
                              <Button
                                size="small"
                                onClick={() => openModal(item?.id)}
                                style={{
                                  marginTop: 5,
                                  width: 150
                                }}
                                variant="outlined"
                                component={RouterLink}
                                to="#"
                                startIcon={<Iconify color={pallete.primary.main} icon="bx:edit" />}
                              >
                                change status
                              </Button>
                            )}
                            {permission.includes('details') && (
                              <Button
                                size="small"
                                style={{
                                  marginTop: 5,
                                  width: 150
                                }}
                                variant="outlined"
                                component={RouterLink}
                                to="#"
                                startIcon={<Iconify color={pallete.primary.main} icon="gg:notes" />}
                                onClick={(event) => {
                                  event.preventDefault();
                                  event.stopPropagation();
                                  handleOrderClick(item?.order);
                                }}
                              >
                                Details
                              </Button>
                            )}
                          </Box> */}
                          <Box display="flex" flexDirection="row" m={0}>
                            {permission.includes('change status') && (
                              <Tooltip title="Change Status">
                                <LoadingButton
                                  size="small"
                                  onClick={() => {
                                    openModal(item?.id);
                                    setstatusmodal(
                                      statuslist.find(
                                        (items) => items?.name?.toLowerCase() == item?.status
                                      )
                                    );
                                  }}
                                  style={{
                                    justifyContent: 'center',
                                    width: 30, // Less than 30
                                    height: 30, // Ensuring it's a square button
                                    minWidth: 30, // Ensuring minimum width is set to 30
                                    padding: 0, // Removing padding to fit the icon properly
                                    lineHeight: 1, // Ensuring the icon is centered
                                    alignSelf: 'center',
                                    marginLeft: 1
                                  }}
                                  component={RouterLink}
                                  to="#"
                                >
                                  <Iconify
                                    style={{ cursor: 'pointer', fontSize: 20 }}
                                    icon="tabler:status-change"
                                  />
                                </LoadingButton>
                              </Tooltip>
                            )}
                            {permission.includes('details') && (
                              <Tooltip title="View Details">
                                <LoadingButton
                                  size="small"
                                  onClick={(event) => {
                                    event.preventDefault();
                                    event.stopPropagation();
                                    handleOrderClick(item?.order);
                                  }}
                                  style={{
                                    justifyContent: 'center',
                                    width: 30, // Less than 30
                                    height: 30, // Ensuring it's a square button
                                    minWidth: 30, // Ensuring minimum width is set to 30
                                    padding: 0, // Removing padding to fit the icon properly
                                    lineHeight: 1, // Ensuring the icon is centered
                                    alignSelf: 'center',
                                    marginLeft: 1
                                  }}
                                  component={RouterLink}
                                  to="#"
                                >
                                  <Iconify
                                    style={{ cursor: 'pointer', fontSize: 18 }}
                                    icon="gg:notes"
                                  />
                                </LoadingButton>
                              </Tooltip>
                            )}
                          </Box>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
                {isDataFound && !loading && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={12} sx={{ py: 3 }}>
                        <SearchNotFound searchQuery={search} />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
              {loading && (
                <Box
                  py={5}
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    flex: 1
                  }}
                >
                  <CircularProgress />
                </Box>
              )}
            </Scrollbar>
          </TableContainer>
        </Card>
        {!loading && !searchLoading && pagesCount > 1 && (
          <Box
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'flex-end',
              marginTop: 10,
              alignItems: 'center'
            }}
          >
            <Pagination
              count={pagesCount}
              color="primary"
              variant="outlined"
              shape="rounded"
              onChange={handlePageChange}
              page={page}
            />
          </Box>
        )}
      </Container>
    </Page>
  );
}
